export enum CredentialEnum {
  DostępDoWarunkówHalowych = 1,
  DostępDoCenPoRabacie = 2,
  WidziWszystkieZamówienia = 3,
  MożeZamawiać = 4,
  MożeZamawiaćZleceniaPośrednie = 5,
}
